var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M18 12h-6v6h-2v-6H4v-2h6V4h2v6h6z"}})}
var staticRenderFns = []

export { render, staticRenderFns }